import { z } from "zod";

import {
  CreateExperienceProductDtoSchema,
  S3FileLocationDtoSchema,
} from "@intelligems/ig-types";

export const IExperienceProductsStateSchema = z.object({
  isSuccess: z.boolean(),
  experienceProducts: CreateExperienceProductDtoSchema.array(),
  storedExperienceProducts: CreateExperienceProductDtoSchema.array(),
  allProductsLoaded: z.boolean(),
  isUploadingProducts: z.boolean(),
  isFileLoaded: z.boolean(),
  productsLocation: S3FileLocationDtoSchema.nullish(),
  hasNextPage: z.boolean(),
  isFetching: z.boolean(),
  isLoading: z.boolean(),
  loadingCount: z.number(),
});

export type IExperienceProductsState = z.infer<
  typeof IExperienceProductsStateSchema
>;

export const sliceInitialExperienceProductsState: IExperienceProductsState = {
  isSuccess: false,
  experienceProducts: [],
  storedExperienceProducts: [],
  allProductsLoaded: false,
  isUploadingProducts: false,
  isFileLoaded: false,
  productsLocation: null,
  hasNextPage: true,
  isFetching: false,
  loadingCount: 0,
  isLoading: false,
};
